import { useRequestContext } from '@coolblue-development/next-request-context/client';

import { routes } from './data/legacyRoutes';
import { RouteName } from './routes';

export const useClientUrl = (
  routeName: RouteName,
  queryParams?: Record<string, string> | string[][]
): string | undefined => {
  const { subsidiary, language } = useRequestContext();
  const route = routes[routeName]?.[subsidiary]?.[language];

  if (!route) {
    return undefined;
  }

  const queryString = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : '';
  return `${route}${queryString}`;
};
